/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ScanWaypointType {
}

export enum ScanWaypointType_Enum {
  INVALID = 0,
  PHOTO = 1,
  EXPLORATION = 2,
  A_STAR = 3,
  SPEED = 4,
  EXPLORATION_COVERAGE = 5,
  EXPLORATION_RANGING = 6,
  EXPLORATION_CORRESPONDENCE = 7,
  EXPLORATION_MEASUREMENT = 8,
  EXPLORATION_MEASUREMENT_AND_OPTIMIZATION = 9,
  UNRECOGNIZED = -1,
}

export function scanWaypointType_EnumFromJSON(object: any): ScanWaypointType_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return ScanWaypointType_Enum.INVALID;
    case 1:
    case "PHOTO":
      return ScanWaypointType_Enum.PHOTO;
    case 2:
    case "EXPLORATION":
      return ScanWaypointType_Enum.EXPLORATION;
    case 3:
    case "A_STAR":
      return ScanWaypointType_Enum.A_STAR;
    case 4:
    case "SPEED":
      return ScanWaypointType_Enum.SPEED;
    case 5:
    case "EXPLORATION_COVERAGE":
      return ScanWaypointType_Enum.EXPLORATION_COVERAGE;
    case 6:
    case "EXPLORATION_RANGING":
      return ScanWaypointType_Enum.EXPLORATION_RANGING;
    case 7:
    case "EXPLORATION_CORRESPONDENCE":
      return ScanWaypointType_Enum.EXPLORATION_CORRESPONDENCE;
    case 8:
    case "EXPLORATION_MEASUREMENT":
      return ScanWaypointType_Enum.EXPLORATION_MEASUREMENT;
    case 9:
    case "EXPLORATION_MEASUREMENT_AND_OPTIMIZATION":
      return ScanWaypointType_Enum.EXPLORATION_MEASUREMENT_AND_OPTIMIZATION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScanWaypointType_Enum.UNRECOGNIZED;
  }
}

export function scanWaypointType_EnumToJSON(object: ScanWaypointType_Enum): string {
  switch (object) {
    case ScanWaypointType_Enum.INVALID:
      return "INVALID";
    case ScanWaypointType_Enum.PHOTO:
      return "PHOTO";
    case ScanWaypointType_Enum.EXPLORATION:
      return "EXPLORATION";
    case ScanWaypointType_Enum.A_STAR:
      return "A_STAR";
    case ScanWaypointType_Enum.SPEED:
      return "SPEED";
    case ScanWaypointType_Enum.EXPLORATION_COVERAGE:
      return "EXPLORATION_COVERAGE";
    case ScanWaypointType_Enum.EXPLORATION_RANGING:
      return "EXPLORATION_RANGING";
    case ScanWaypointType_Enum.EXPLORATION_CORRESPONDENCE:
      return "EXPLORATION_CORRESPONDENCE";
    case ScanWaypointType_Enum.EXPLORATION_MEASUREMENT:
      return "EXPLORATION_MEASUREMENT";
    case ScanWaypointType_Enum.EXPLORATION_MEASUREMENT_AND_OPTIMIZATION:
      return "EXPLORATION_MEASUREMENT_AND_OPTIMIZATION";
    case ScanWaypointType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseScanWaypointType(): ScanWaypointType {
  return {};
}

export const ScanWaypointType = {
  encode(_: ScanWaypointType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ScanWaypointType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScanWaypointType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ScanWaypointType {
    return {};
  },

  toJSON(_: ScanWaypointType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ScanWaypointType>, I>>(base?: I): ScanWaypointType {
    return ScanWaypointType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScanWaypointType>, I>>(_: I): ScanWaypointType {
    const message = createBaseScanWaypointType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
